import Resizer from "react-image-file-resizer";

    const checkImageSize = async (file) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = (event) => {
            const image = new Image();
            image.src = event.target.result;
            image.onload = () => {
              resolve({width: image.width, height: image.height });
              return {width: image.width, height: image.height };
            };
            reader.onerror = (err) => reject(err);
          };
        });
      };

    const ResizeImg = async (file) => {
        // max pixel size (longest side)
        const MAX_SIZE = 1600;       
        const img_size = await checkImageSize(file);

        // calc resized height and length
        const rawHeight = img_size.height;
        const rawWidth = img_size.width;
        const ratio = rawWidth / rawHeight;
        let wantedwidth = MAX_SIZE;
        let wantedheight = MAX_SIZE;
        if(rawHeight > rawWidth){
            wantedwidth = Math.round(MAX_SIZE*ratio);
        } else {
            wantedheight = Math.round(MAX_SIZE/ratio);
        }

        return(new Promise((resolve) => {
            Resizer.imageFileResizer(
            file,
            wantedwidth,
            wantedheight,
            "JPEG",
            100,
            0,
            (uri) => {
                resolve(uri);
            },
            "file"
            );
        }))
    }

export default ResizeImg;